import $ from "jquery";
import BD_Component from "@bd-core/bd-component";
import compile from "@bd-utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getRoomStatus, getFinalTeamAnswers } from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import 'slick-carousel'
import videojs from "video.js";
import {
    maybeUpdateRoomStatus,
    getFinalRoomAnswers,
    updateRoomAnswer,
    getRoomAnswers,
    saveFinalRoomAnswers,
} from "@bd-core/firebase-actions";

export class RoomCluesEquations extends BD_Component {
    constructor() {
        super();
        this.id = "clues_equations";
        this.templateID = "clues_equations-template";

        this.elms = {
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-submit-btn",
            background: ".js-screen-img",
            thumbnail: ".js-thumbnail",
            closeImgBtn: ".js-close-image",
            closeCardBtn: ".js-close-card",
            closeBriefBtn: ".js-close-briefing",
            openChallenge: ".js-open-challenge",
            imageViewPopup: ".js-image",
            questionPopup: ".js-card",
            imageSlider: ".js-slider",
            prevBtn: ".js-req-prev",
            nextBtn: ".js-req-next",
            fileBtn: ".js-shareFile-btn",
            audioBtn: ".js-shareAudio-btn",
            videoBtn: ".js-shareVideo-btn",
            closeSharingBtn: ".js-close-sharing",
            fileItem: ".js-file-item",
            handleAudioBtn: ".js-audio-btn",
            handleVideoBtn: ".js-video-btn"
        };

        this._events = this.getEvents();
        this.userAnswer = undefined;
        this.video = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "blur",
                selector: elms.inputAnswer,
                handler: this.onBlurInput,
            },
            {
                event: "focus",
                selector: elms.inputAnswer,
                handler: this.onInputFocus,
            },
            {
                event: "keypress",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
            {
                event: "click",
                selector: elms.checkAnswer,
                handler: this.checkAnswer,
            },
            {
                event: "click",
                selector: elms.thumbnail,
                handler: this.openImage,
            },
            {
                event: "click",
                selector: elms.closeImgBtn,
                handler: this.closeImage,
            },
            {
                event: "click",
                selector: elms.closeCardBtn,
                handler: this.closePuzzleSharingData
            },
            {
                event: "click",
                selector: elms.openChallenge,
                handler: this.openChallenge,
            },
            {
                event: "click",
                selector: elms.fileBtn,
                handler: this.openFile,
            },
            {
                event: "click",
                selector: elms.audioBtn,
                handler: this.openAudio,
            },
            {
                event: "click",
                selector: elms.videoBtn,
                handler: this.openVideo,
            },
            {
                event: "click",
                selector: elms.closeSharingBtn,
                handler: this.closeSharingView,
            },
            {
                event: "click",
                selector: elms.fileItem,
                handler: this.openFileItem,
            },
            {
                event: "keyup",
                selector: elms.inputAnswer,
                handler: this.onDeleteInputAnswer
            },
            {
                event: "click",
                selector: elms.handleAudioBtn,
                handler: this.playOrPauseAudio
            },
            {
                event: "click",
                selector: elms.handleVideoBtn,
                handler: this.playOrPauseVideo
            }
        ];
    }

    beforeInit() {
        this.renameElementClass();
        this.render();
        this.setGameState();
        this.setCapthchaSlider();
        this.setVideo();

        const $audio = $(".js-room-element-audio");
    
        if ($audio.length) {
            $audio[0].addEventListener("ended", function() {
                $(".js-audio-btn").addClass("is-paused")
                $(".js-audio-btn").removeClass("is-playing")
            });
        }
    }

    renameElementClass() {
        const { template } = this._data;

        if (template === "sharing_data") {
            this.elms = {
                ...this.elms,
                questionPopup: ".js-card-ch-3"
            };
        }
    }

    getModifiedData() {
        const modifiedData = { ...this._data };
        
        // @ts-ignore
        const {template} = modifiedData;
        let defaultImageBg = `${CONFIG.themeURL}/assets/images/challenge1-bg.png`;

        if(template === "sharing_data") {
            defaultImageBg = `${CONFIG.themeURL}/assets/images/challenge3-bg.png`;
        }

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const modified = {
            ...modifiedData,
            image_bg: _image_bg,
        };

        return modified;
    }

    render() {
        const data = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, data);
        $(".app").html(html);
    }

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);
        const teamAnswers = getFinalTeamAnswers(roomId);

        const self = this;
        const elms = self.elms;
        const $questionPopup = $(elms.questionPopup);
        const $inputAnswer = $(elms.inputAnswer);
        const $submitBtn = $(elms.checkAnswer);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (teamAnswers) {
            const answers =
                typeof teamAnswers === "string"
                    ? [...teamAnswers]
                    : teamAnswers;

            if (Object.keys(answers).length == 0) return;

            $.each(answers, (index, value) => {
                $questionPopup
                    .find($inputAnswer)
                    .eq(index)
                    .prop("readonly", true)
                    .val(value);
            });

            if (thisRoomStatus == "is-status-completed") {
                $(".app__page").addClass("is-room-completed");
                $submitBtn.addClass("is-completed");
                $questionPopup
                    .removeClass("is-wrong")
                    .addClass("is-correct");
            }
        }
    }

    setCapthchaSlider() {
        $(".js-captcha-slider").slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $(".js-prev"),
            nextArrow: $(".js-next"),
            dots: true,
            appendDots: $(".js-paging"),
            customPaging: function (slider, i) {
                // eslint-disable-next-line no-unused-vars
                var thumb = $(slider.$slides[i]).data(); // Ensure data attributes are defined in the slides
                return '<a>' + '</a>';
            }
        });

        $(".js-captcha-slider").on('beforeChange', function(event, slick, currentSlide, nextSlide){
            $(".js-prev").prop('disabled', nextSlide === 0);
            $(".js-next").prop('disabled', nextSlide === slick.slideCount - 1);
        });
    }

    setVideo() {
        const self = this;
        const $video = $("#sharingVideo");
        if(!$video.length) return;

        const videoUrl = $video.attr("data-src");
        if (!videoUrl || videoUrl === "false") return;

        if(self.video !== null) return;

        this.video = videojs("#sharingVideo", {
            controls: true,
            autoplay: false,
            preload: "auto",
            sources: [
                {
                    src: videoUrl,
                    type: "video/mp4",
                },
            ],
            techOrder: ["html5"]
        });

        this.video.on("error", () => {
            console.error("Can't play the video");
        });

        this.video.on("ended", () => {
            $(".js-video-btn").addClass("is-paused")
            $(".js-video-btn").removeClass("is-playing")
        });
    }

    // ============================== CUSTOM FUNCTION
    playOrPauseVideo() {
        const theVideo = this.video;
        const isPaused = theVideo.paused();

        if(isPaused) {
            try {
                $(".js-video-btn").removeClass("is-paused")
                $(".js-video-btn").addClass("is-playing")
                theVideo.play().catch((error) => {
                    console.error("Unable to start auto play", error);
                });
            } catch (error) {
                console.error(error);
            }
        } else {
            theVideo.pause();
            $(".js-video-btn").addClass("is-paused")
            $(".js-video-btn").removeClass("is-playing")
        }
    }

    openFile() {
        this.closePuzzleSharingData();
        $(".js-shareFile").addClass("is-open is-file");
        $(".js-app-back").addClass("hidden")

    }
    openVideo() {
        this.closePuzzleSharingData();
        $(".js-shareFile").addClass("is-open is-video");
        $(".js-app-back").addClass("hidden");
    }

    openAudio() {
        this.closePuzzleSharingData();
        $(".js-shareFile").addClass("is-open is-audio");
        $(".js-app-back").addClass("hidden");
    }

    playOrPauseAudio() {
        /**
         * @type {JQuery<HTMLAudioElement>}
         */

        const $audio = $(".js-room-element-audio");
        if (!$audio.length) return;

        const isPaused = $audio[0].paused;

        if(isPaused) {
            this.playAudio();
            $(".js-audio-btn").removeClass("is-paused")
            $(".js-audio-btn").addClass("is-playing")
        } else {
            this.pauseAudio();
            $(".js-audio-btn").addClass("is-paused")
            $(".js-audio-btn").removeClass("is-playing")
        }
    }

    playAudio() {
        /**
         * @type {JQuery<HTMLAudioElement>}
         */
        const $audio = $(".js-room-element-audio");
        if (!$audio.length) return;

        const isPaused = $audio[0].paused;
        if (!isPaused) return;

        const $thisBtn = $(this.elms.handleAudioBtn);
        $audio[0]
            .play()
            .then(() => $thisBtn.addClass("is-playing"))
            .catch((err) => console.error("Can't auto-play audio", err));
    }

    pauseAudio() {
        /**
         * @type {JQuery<HTMLAudioElement>}
         */
        const $audio = $(".js-room-element-audio");
        if (!$audio.length) return;

        const isPaused = $audio[0].paused;
        if (isPaused) return;

        const $thisBtn = $(this.elms.handleAudioBtn);

        try {
            $audio[0].pause();
            $thisBtn.removeClass("is-playing");
        } catch (err) {
            console.error("Can't pause audio", err);
        }
    }

    closeSharingView(e, el) {
        const $this = $(el);
        const $popup = $this.parents(".js-shareFile");
        const isAudio = $popup.hasClass("is-audio");
        const isVideo = $popup.hasClass("is-video");

        if (isAudio) this.pauseAudio();

        if (isVideo) {
            // @ts-ignore
            $("#sharingVideo")[0].player.pause();
        }

        $popup.removeClass("is-open is-audio is-video is-file");

        $(".js-app-back").removeClass("hidden")
    }

    openFileItem(e, el) {
        const elms = this.elms;
        const $this = $(el);
        const $parent = $this.parent();
        const $documents = $parent.find(elms.fileItem);

        $.each($documents, (index, value) => {
            $(value).not($this).removeClass("is-active");
        });

        const isActive = $this.hasClass("is-active");

        if (!isActive) {
            $this.addClass("is-active")
        } else {
            $this.removeClass("is-active")
        }
    }

    openImage(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);
        const imgUrl = $this.attr("src");
        const $selectedImageScreen = $(".js-selected-image");
        const $imageViewPopup = $(elms.imageViewPopup);

        $selectedImageScreen.attr("src", imgUrl);
        $imageViewPopup.addClass("is-open");
    }

    closeImage() {
        $(".js-image").removeClass("is-open")
    }

    closePuzzleSharingData() {
        $(".js-card-ch-3").removeClass("is-open");
    }

    openChallenge() {
        const elms = this.elms;

        $(elms.questionPopup).addClass("is-open");
        $(elms.imageSlider).addClass("is-open");
    }

    inputAnswer(e, el) {
        e.preventDefault();

        const $el = $(el);
        const elms = this.elms;
        const $submitBtn = $(elms.checkAnswer);
        const $questionPopup = $(elms.questionPopup);

        if ($submitBtn.hasClass("is-completed")) {
            return false;
        }

        $questionPopup.removeClass("is-wrong");

        const regex = new RegExp("^[a-zA-Z0-9]+$");
        const key = String.fromCharCode(!e.keyCode ? e.which : e.keyCode);

        if (!regex.test(key)) {
            this.toggleCheckButton();
            return false;
        }

        const value = String($el.val(e.key));
        const $current = $el.parent();
        const $nextInput = $current.next();

        if (value.trim() !== "" && $nextInput.length) {
            $el.trigger("blur");
            $nextInput.find("input").trigger("focus");
        }

        this.toggleCheckButton();
    }

    onDeleteInputAnswer(e, el) {
        const $el = $(el);
        const keyCode = e.keyCode || e.which;
        const isDeleteKey = keyCode === 8;
        const $current = $el.parent();
        const $previousInput = $current.prev();

        if (!isDeleteKey) return;

        $current.find("input").val("");
        $previousInput.find("input").trigger("focus");

        this.toggleCheckButton();
    }

    toggleCheckButton() {
        const elms = this.elms;
        const $questionPopup = $(elms.questionPopup);
        const $checkBtn = $questionPopup.find(elms.checkAnswer);
        const $answers = $questionPopup.find(elms.inputAnswer);
        let isAllAnswered = true;

        $.each($answers, function (index, elAnswer) {
            const answer = String($(elAnswer).val());
            if (answer.trim() == "") {
                isAllAnswered = false;
                return false;
            }
        });

        return $checkBtn
            .prop("disabled", !isAllAnswered)
            .toggleClass("valid", isAllAnswered);
    }

    checkAnswer(e, el) {
        const $el = $(el);
        const elms = this.elms;

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        const $questionPopup = $el.parents(elms.questionPopup);
        const $answers = $questionPopup.find(elms.inputAnswer);

        $el.addClass("is-loading").prop("disabled", true);
        $questionPopup.removeClass("is-wrong");

        const roomId = this.roomId;
        const roomAnswers = getRoomAnswerById(roomId);

        let roomStatus = "is-status-started";
        let isCorrect = false;
        let playerAnswer = "";

        $.each($answers, function (index, answer) {
            const $answer = $(answer);
            playerAnswer += $answer.val();
        });

        const correctAnswer = roomAnswers?.code || false;

        playerAnswer = playerAnswer.toLowerCase();

        if (playerAnswer === correctAnswer) {
            isCorrect = true;
        }

        const updateData = playerAnswer;

        if (isCorrect) {
            $questionPopup
                .removeClass("is-wrong")
                .addClass("is-correct");
            $answers.prop("readonly", true);

            $el
                .removeClass("is-loading valid")
                .addClass("is-completed");

            const onSuccessUpdate = () => {
                maybeUpdateRoomStatus(roomId, "is-status-completed");
            };

            const onErrorUpdate = () => { };

            saveFinalRoomAnswers(roomId, updateData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);

            $el.removeClass("is-loading valid");
        } else {
            $questionPopup.addClass("is-wrong");
            $el.removeClass("is-loading");

            maybeUpdateRoomStatus(roomId, roomStatus);
        }
    }

    maybeRoomIsFinish() {
        const roomId = this.roomId;
        getFinalRoomAnswers(roomId).then((data) => {
            const roomAnswers = getRoomAnswerById(roomId);
            const fbRoomAnswers = data.val();

            if (
                !fbRoomAnswers ||
                typeof roomAnswers !== "string" ||
                typeof fbRoomAnswers !== "string"
            ) {
                return;
            }

            if (
                Object.keys(roomAnswers).length ==
                Object.keys(fbRoomAnswers).length
            ) {
                maybeUpdateRoomStatus(roomId, "is-status-completed");
            }
        });
    }

    onBlurInput(e) {
        let $this = $(e.currentTarget);
        let val = String($this.val());
        let display = $this.next();

        display.removeClass("on-input");
        display.text(val.trim());
    }

    onInputFocus(e) {
        const $this = $(e.currentTarget);
        const display = $this.next();
        const val = String($this.val());

        display.addClass("on-input");

        if (val.trim() === "") {
            display.text("");
        }

        if (val.trim().length) {
            $this[0].setSelectionRange(val.length - 1, val.length);
        }
    }

    updateUserAnswer() {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const answer = this.userAnswer;

            const userAnswer = fbRoomAnswers[currentPlayerId]?.choice;
            const answerData = { ...userAnswer, ...answer };

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: answerData,
                },
            });
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[questionID]) {
                    const answer = thisPlayerAnswer[questionID].answer;
                    const user = {
                        ...player,
                        answer: answer,
                    };

                    return user;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }

    beforeDestroy() {
        const $video = $("#sharingVideo");
        if(!$video.length) return;
        
        this.video.dispose();
        this.video = null;
    }
}
